// extracted by mini-css-extract-plugin
export var bg04_t = "RecruitCultureBgTop-module--bg04_t--2oeEn";
export var _186 = "RecruitCultureBgTop-module--_186--2byoV";